import React from "react";
import { useQuery } from "react-apollo-hooks";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import Button from "../../components/Button";
import { Col, Row } from "../../components/Grid";
import { query } from "./ProductsPage";
import filterProducts from "./filterProducts";

export default function ProductsNavigation({
  previousProduct,
  nextProduct,
  children
}) {
  return (
    <Row
      justifyContent="space-between"
      minHeight="36px"
      flexWrap="nowrap"
      alignItems="center"
    >
      {previousProduct && (
        <Col>
          <Button
            to={`../${previousProduct.id}`}
            size="sm"
            title={
              previousProduct.productName &&
              previousProduct.productName.shortName
            }
          >
            <FiChevronLeft css={{ verticalAlign: "middle" }} />
          </Button>
        </Col>
      )}
      <Col flex={1}>{children}</Col>
      {nextProduct && (
        <Col>
          <Button
            to={`../${nextProduct.id}`}
            size="sm"
            title={nextProduct.productName && nextProduct.productName.shortName}
          >
            <FiChevronRight css={{ verticalAlign: "middle" }} />
          </Button>
        </Col>
      )}
    </Row>
  );
}

export function useProductsQuery(options) {
  const { data } = useQuery(query, options);
  const { filter, event } = data || {};
  const { productsConnection: { edges } = {} } = event || {};
  if (!edges) return [];
  return filterProducts(edges.map(({ node }) => node), filter);
}

export function findAdjacentProducts(products, productId) {
  // TODO for now, a simple solution for prev and next. Later this should come from a client side query.
  const productIndex = products.findIndex(({ id }) => id === productId);
  const previousProduct =
    productIndex <= 0 ? undefined : products[productIndex - 1];
  const nextProduct =
    productIndex >= products.length - 1
      ? undefined
      : products[productIndex + 1];
  return { previousProduct, nextProduct };
}
